import { render, staticRenderFns } from "./SocialId.vue?vue&type=template&id=7f43a400"
import script from "./SocialId.vue?vue&type=script&lang=js"
export * from "./SocialId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports